/* Marcel Afters, SITE-ALIVE (25 Sep 2026): the rotator (snippets/ma-motion-hero.liquid, alias ma-rotator). Frames are
   built after load + idle once the block is near the viewport. Under prefers-reduced-motion or Save-Data nothing moves by
   itself: the dots still work, with no drift. */
(() => {
  if (window.__maMo) return;
  window.__maMo = 1;
  const INT = 4500;
  const manual = matchMedia('(prefers-reduced-motion: reduce)').matches || !!(navigator.connection && navigator.connection.saveData);
  const idle = window.requestIdleCallback ? (f) => requestIdleCallback(f, { timeout: 2500 }) : (f) => setTimeout(f, 1200);
  const ICON = '<svg class="ma-mo__i-pause" viewBox="0 0 10 10" aria-hidden="true"><rect x="1.5" y="1" width="2.4" height="8"/><rect x="6.1" y="1" width="2.4" height="8"/></svg><svg class="ma-mo__i-play" viewBox="0 0 10 10" aria-hidden="true"><path d="M2 1l7 4-7 4z"/></svg>';

  function build(root) {
    if (root.__mo) return;
    const box = root.getBoundingClientRect();
    if (!box.width || !box.height) return;
    root.__mo = 1;
    const el = root.querySelector('.ma-mo__data');
    let data = [];
    try { data = JSON.parse(el ? el.textContent : '[]'); } catch (e) { return; }
    if (!data.length) return;
    const first = root.querySelector('.ma-mo__f--first');
    const desk = matchMedia('(min-width: 750px)').matches;
    if (!desk) data = data.map((d) => (d.m ? { ...d, s: d.m, ss: d.ms, w: d.mw, h: d.mh } : d));
    const inset = desk ? parseFloat(root.dataset.inset || 0) : 0;
    const usable = box.width * (1 - inset / 100);
    const per = usable / box.height > 1.2 ? 2 : 1;
    const groups = [];
    let run = [];
    data.forEach((d) => {
      if (d.w / d.h > 1.1) { groups.push({ items: [d], wide: true }); return; }
      run.push(d);
      if (run.length === per) { groups.push({ items: run }); run = []; }
    });
    const slides = [first];
    groups.forEach((gp) => {
      const f = document.createElement('div');
      const ins = inset && !gp.wide;
      f.className = 'ma-mo__f' + (ins ? ' ma-mo__f--inset' : '');
      if (ins) f.style.setProperty('--ma-mo-inset', inset + '%');
      f.setAttribute('aria-hidden', 'true');
      const cellW = Math.round((gp.wide ? box.width : usable) / gp.items.length);
      gp.items.forEach((d) => {
        const c = document.createElement('div');
        c.className = 'ma-mo__cell';
        const im = new Image();
        im.className = 'ma-mo__img';
        im.alt = d.a || '';
        im.decoding = 'async';
        im.width = d.w; im.height = d.h;
        im.sizes = cellW + 'px';
        if (gp.wide) im.style.objectPosition = '50% 35%';
        im.dataset.src = d.s; im.dataset.srcset = d.ss;
        c.appendChild(im);
        f.appendChild(c);
      });
      root.appendChild(f);
      slides.push(f);
    });
    if (slides.length < 2) return;
    root.style.setProperty('--ma-mo-int', INT + 'ms');
    root.style.setProperty('--ma-mo-dur', (INT + 1600) + 'ms');

    let cur = 0, elapsed = -parseFloat(root.dataset.offset || 0), held = manual, hover = false, focus = false, seen = true, busy = false, alt = false, pend = null;
    const ui = document.createElement('div');
    ui.className = 'ma-mo__ui';
    const dots = document.createElement('div');
    dots.className = 'ma-mo__dots';
    const dotEls = slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ma-mo__dot';
      b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + slides.length);
      b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(i); });
      dots.appendChild(b);
      return b;
    });
    ui.appendChild(dots);
    if (!manual) {
      const pp = document.createElement('button');
      pp.type = 'button';
      pp.className = 'ma-mo__pp';
      pp.setAttribute('aria-label', 'Pause slideshow');
      pp.innerHTML = ICON;
      pp.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        held = !held;
        root.classList.toggle('is-held', held);
        pp.setAttribute('aria-label', held ? 'Play slideshow' : 'Pause slideshow');
        sync();
      });
      ui.appendChild(pp);
    }
    root.appendChild(ui);

    const load = (s) => {
      s.querySelectorAll('img[data-src]').forEach((im) => { im.srcset = im.dataset.srcset; im.src = im.dataset.src; delete im.dataset.src; });
      const shown = [...s.querySelectorAll('img')].filter((im) => im.getClientRects().length);
      const ready = Promise.all(shown.map((im) => (im.complete && im.naturalWidth ? 1 : im.decode ? im.decode().catch(() => 1) : 1)));
      return Promise.race([ready, new Promise((r) => setTimeout(r, 3000))]);
    };
    const paused = () => held || hover || focus || !seen || document.hidden;
    const sync = () => root.classList.toggle('is-paused', paused());
    const mark = () => dotEls.forEach((d, i) => { d.classList.toggle('is-on', i === cur); d.classList.toggle('is-done', i < cur); d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });

    function go(n) {
      n = (n + slides.length) % slides.length;
      if (busy) { pend = n; return; }
      if (n === cur) return;
      busy = true;
      const a = slides[cur], b = slides[n];
      load(b).then(() => {
        alt = !alt;
        b.classList.toggle('is-alt', alt);
        b.classList.remove('is-kb');
        void b.offsetWidth;
        b.classList.add('is-on');
        if (!manual) b.classList.add('is-kb');
        b.removeAttribute('aria-hidden');
        a.classList.remove('is-on');
        a.classList.add('is-out');
        a.setAttribute('aria-hidden', 'true');
        setTimeout(() => {
          a.classList.remove('is-out', 'is-kb');
          busy = false;
          if (pend !== null) { const q = pend; pend = null; go(q); }
        }, manual ? 50 : 1500);
        cur = n; elapsed = 0; mark();
        const nx = slides[(n + 1) % slides.length];
        idle(() => load(nx));
      });
    }

    root.classList.add('is-live');
    root.classList.toggle('is-manual', manual);
    root.classList.toggle('is-held', held);
    if (!manual) first.classList.add('is-kb');
    mark();
    sync();
    idle(() => load(slides[1]));
    setInterval(() => {
      if (paused()) return;
      elapsed += 200;
      if (elapsed >= INT && !busy) go(cur + 1);
    }, 200);

    root.addEventListener('mouseenter', () => { hover = true; sync(); });
    root.addEventListener('mouseleave', () => { hover = false; sync(); });
    root.addEventListener('focusin', () => { focus = true; sync(); });
    root.addEventListener('focusout', () => { focus = false; sync(); });
    document.addEventListener('visibilitychange', sync);
    new IntersectionObserver((es) => { seen = es[0].isIntersecting; sync(); }, { threshold: 0.2 }).observe(root);

    let x0 = null, y0 = 0, swiped = false;
    root.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; x0 = e.clientX; y0 = e.clientY; swiped = false; });
    root.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) { swiped = true; go(cur + (dx < 0 ? 1 : -1)); }
    });
    root.addEventListener('pointercancel', () => { x0 = null; });
    root.addEventListener('click', (e) => { if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; } }, true);
  }

  function start() {
    const roots = [...document.querySelectorAll('[data-ma-mo]')];
    if (!roots.length) return;
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); idle(() => build(e.target)); } });
    }, { rootMargin: '300px 0px' });
    roots.forEach((r) => io.observe(r));
    window.maRotatorScan = () => document.querySelectorAll('[data-ma-mo]').forEach((r) => { if (!r.__mo) io.observe(r); });
  }
  if (document.readyState === 'complete') idle(start);
  else window.addEventListener('load', () => idle(start), { once: true });
})();
